




































































































import { apiOrderOrderDeliverList } from '@/api'
import { asRequiredDeep, wait } from 'vtils'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useQuery } from '@/hooks'
import { InstantDeliveryComponents } from './components'
import { navigateTo } from '@/router'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: InstantDeliveryComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '我的配送订单',
        }))
      }

      loading = computed(() => false)

      query = useQuery<{
        orderNo: string
      }>()

      statusData = [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '待付款',
          value: 1,
        },
        {
          label: '待接单',
          value: 7,
        },
        {
          label: '待配送',
          value: 8,
        },
        {
          label: '配送中',
          value: 9,
        },
        {
          label: '已完成',
          value: 5,
        },
        {
          label: '待评价',
          value: 4,
        },
        {
          label: '退款/售后',
          value: 10,
        },
      ]

      statusIndex = ref(0)

      // 加载数据
      handleDataLoad = ({ pageNumber }: any) => {
        return apiOrderOrderDeliverList({
          pageIndex: pageNumber,
          pageSize: 10,
          status: this.statusData[this.statusIndex.value].value,
        })
      }

      handleCheck = async (item: any) => {
        await wait(1000)
        const {
          list: [newItem],
        } = await apiOrderOrderDeliverList({
          pageIndex: 1,
          pageSize: 1,
          status: this.statusData[this.statusIndex.value].value,
          orderNo: item.orderNo,
        }).then(asRequiredDeep)
        return newItem
      }

      // 点击查看订单
      handleOrderClick = (orderNo: string) => {
        navigateTo('InstantDeliveryOrderDetail', {
          orderNo: orderNo,
        })
      }
    },
)
